import 'core-js/actual';

// Some browsers require polyfills for the native JS 'animate' API
import 'web-animations-js';

// Some browsers require this polyfill in order for window.scroll with smooth behaviour to work
import * as smoothscroll from 'smoothscroll-polyfill'; // npm install --save smoothscroll-polyfill
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
smoothscroll.polyfill();
